import ButtonInputModal from './toolbar/buttonInputModal.js';
import 'prop-types';
import 'react';
import 'lodash';
import 'react-custom-scrollbars';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-common';
import './components/design-component.js';
import 'wix-rich-content-plugin-commons';
import './components/color-toggle-component.js';
import 'classnames';
import './style-inject.es-746bb8ed.js';
import './constants.js';
import 'ricos-schema';
import './types.js';
import './defaults.js';
import './components/settings-component.js';
import './components/preview-component.js';
import './button-component.js';
import './classNameStrategies.js';
import './default-styles-74c82233.js';
import './components/button-viewer.js';
import './viewer/button-viewer.js';
import 'ricos-context';

const Modals = {
  BUTTON_INPUT: "button-input"
};
const ModalsMap = {
  [Modals.BUTTON_INPUT]: ButtonInputModal
};

export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map
